// origins allowed to postMessage to the player (beside its own origin): the manager for the preview mode
export const ALLOWED_MESSAGE_ORIGINS = ['https://manager.infomaniak.com'];

/**
 * Check that a message event comes from a trusted origin (the player itself or the manager)
 * @param origin
 * @returns {boolean}
 */
export function isTrustedMessageOrigin(origin) {
    return origin === window.location.origin || ALLOWED_MESSAGE_ORIGINS.includes(origin);
}

/**
 * Find the iframe matching the input regex in the parent window
 *
 * NB: the iframes are found by their location pathname
 * @param pathRegex
 * @returns {Window}
 */
export function getIframeWindowFromParent(pathRegex) {
    const frames = window.parent.frames; // list of the parent frames (non-iterable)
    let splitHistoryWindow;

    for(let i = 0; i < frames.length; i++) {
        // wrap with try catch to prevent CORS error when reading parent iframes origin and location
        try {
            // if the frame pathname match a split history route
            if (frames[i].origin === window.origin && pathRegex.test(frames[i].location.pathname)) {
                splitHistoryWindow = frames[i];
            }
        } catch (error) {
            console.error(error);
        }
    }

    return splitHistoryWindow;
}

